module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider",
    style: ({
      width: _vm.width,
      height: _vm.height
    }),
    attrs: {
      "auto": true
    }
  }, [_c('div', {
    staticClass: "items"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "indicators"
  }, [_vm._t("indicators", _vm._l((_vm.childrenLength), function(i) {
    return _c('span', {
      key: i,
      staticClass: "slider-indicator-icon",
      class: {
        'slider-indicator-active': _vm.nowItemIndex === i - 1
      },
      on: {
        "click": function($event) {
          _vm.indicatorHandle(i - 1)
        }
      }
    })
  }))], 2), _c('button', {
    staticClass: "btn btn-left",
    attrs: {
      "aria-label": "Left Slide"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "slider-icon slider-icon-left"
  })]), _c('button', {
    staticClass: "btn btn-right",
    attrs: {
      "aria-label": "Right Slide"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.next()
      }
    }
  }, [_c('i', {
    staticClass: "slider-icon slider-icon-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba51d164","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider.pug
// module id = 613
// module chunks = 1